import { motion } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

export const SubsidyBenefits = ({ scheme }) => (
  <section className="py-16">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <h2 className="font-heading text-2xl font-semibold text-[#0f172a] mb-8 text-center">
        Benefits & Incentives
      </h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {scheme.benefits.map((benefit, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
          >
            <Card className="h-full border border-slate-100 hover:border-[#00bcd4]/30 transition-colors">
              <CardHeader>
                <CardTitle className="font-heading text-lg text-[#0f172a]">
                  {benefit.category}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2">
                  {benefit.items.map((item, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#00bcd4] mt-2 flex-shrink-0"></span>
                      <span className="text-[#64748b]">{item}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
